/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'adminrole': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M271.267 241.26a241.26 241.26 0 11241.26 241.261 241.26 241.26 0 01-241.26-241.26zM648.538 514.64a304.742 304.742 0 01-273.529 0C118.218 579.929 18.095 821.039 8.444 1024h1007.112C1005 809.127 890.25 577.819 648.538 514.639zm-68.156 382.85l-68.307 58.506-72.98-58.506 42.672-234.023-53.379-67.402 41.768 8.746h83.688l42.673-8.444-48.403 67.1z"/>'
  }
})
